import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { useSetAuthConfig } from 'state';
import { internalAuth } from 'config/oktaConfig';
import { LoaderOverlay } from 'components';

export default function LoginPage() {
    const { oktaAuth } = useOktaAuth();
    const setAuthConfig = useSetAuthConfig();

    useEffect(() => {
        if (oktaAuth.options.clientId === internalAuth.clientId) {
            const url = window.location.href;
            const baseUrl = url.substring(0, url.lastIndexOf("/"));
            const originalUri = toRelativeUrl(baseUrl, window.location.origin);
            oktaAuth.setOriginalUri(originalUri);
            oktaAuth.signInWithRedirect();       
        } else {
            setAuthConfig(internalAuth);
        }
    }, [oktaAuth, setAuthConfig]);

    return <LoaderOverlay isLoading>Redirecting to admin user login...</LoaderOverlay>;
}